import _ from 'underscore';
import React from 'react';
import PropTypes from 'prop-types';

import SizeDependedBlock from 'components/SizeDependedBlock';

import CommonPropTypes from 'utils/propTypes/common';

import { useTabNavigation } from 'hooks/useTabNavigation';
import Item from './components/Item';

import styles from './styles.module.scss';

const Breadcrumbs = ({ items, currentPath, theme }) => {
	const {
		firstListItemRef,
		handleBlur,
		handleFocus,
		handleKeyDown,
		listItemTabIndex
	} = useTabNavigation();
	const preparedItems = items.map(({ path, ...item }) => ({
		...item,
		path: currentPath && currentPath === path ? null : path
	}));
	const mobileItem = _([...preparedItems].reverse()).find(({ path }) => !!path);

	return (
		<div
			className={styles.breadcrumbs}
			aria-label="Хлебные крошки"
			tabIndex={0}
			onKeyDown={handleKeyDown}
			onFocus={handleFocus}
			onBlur={handleBlur}
			role="toolbar"
		>
			<SizeDependedBlock>
				<Item
					title={mobileItem.title}
					path={mobileItem.path}
					theme={theme}
					ref={firstListItemRef}
				/>
				{_(preparedItems).map((item, index) => (
					<Item
						key={item.title}
						title={item.title}
						path={item.path}
						theme={theme}
						tabIndex={listItemTabIndex}
						ref={index === 0 ? firstListItemRef : null}
					/>
				))}
			</SizeDependedBlock>
		</div>
	);
};

Breadcrumbs.propTypes = {
	items: CommonPropTypes.breadcrumbs,
	currentPath: PropTypes.string,
	theme: PropTypes.oneOf(['white'])
};

Breadcrumbs.defaultProps = {
	items: []
};

export default Breadcrumbs;
